import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.less'],
})
export class FormErrorComponent implements OnInit {
  /**
   * 报错信息
   */
  @Input() data: string = '';
  @Input() test: any;

  constructor() {}

  ngOnInit(): void {}
}
